var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBolt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 28,
    viewBox: "0 0 19 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7505 11L12.7505 2H4.79345L2.25445 13H8.16345L6.58245 23.283L15.9745 11H10.7505ZM4.60645 27.92C4.18545 27.741 3.94045 27.3 4.00945 26.848L5.83245 15H0.998453C0.693453 15 0.405454 14.861 0.215454 14.623C0.0254535 14.384 -0.0445469 14.072 0.0234532 13.775L3.02345 0.775C3.12745 0.321 3.53245 0 3.99845 0H13.9985C14.3015 0 14.5875 0.138 14.7785 0.375C14.9675 0.611 15.0405 0.921 14.9745 1.217L13.2455 9H17.9985C18.3785 9 18.7255 9.216 18.8945 9.557C19.0635 9.898 19.0235 10.305 18.7925 10.607L5.79245 27.607C5.59845 27.861 5.30145 28 4.99845 28C4.86645 28 4.73345 27.974 4.60645 27.92Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolt);
export default __webpack_public_path__ + "static/media/bolt.c6a4c330728472b6e852a362c763e5f3.svg";
export { ForwardRef as ReactComponent };